import * as React from "react";
import { Link } from "react-router-dom";
import Logo from "./../assets/img/union_logo_white_long.png";
export default function Footer(props) {
  return (
    <div className="w-full bg-background text-[#000000] text-base">
      <div className="max-w-[1400px] text-[#eee2cd] mx-auto px-4 pt-24 pb-[62px]">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 items-start">
          {/* Logo - takes up 2 columns on desktop, left-aligned */}
          <div className="md:col-span-2 flex justify-center md:justify-start">
            <Link to="/">
              <img
                src={Logo}
                alt="Logo"
                className="w-full max-w-[300px] h-auto object-contain"
              />
            </Link>
          </div>

          {/* Address - takes up 1 column on desktop, centered on mobile */}
          <div className="text-white text-left md:text-left -ml-8 pt-10 md:pt-0 text-lg">
            <ul className="flex flex-col no-left-padding text-left md:items-start space-y-2 font-roboto">
              <li className="font-semibold font-roboto">37-16 Union Street</li>
              <li>Flushing, NY 11354</li>
              <li>646-889-9988</li>
              <li>unioncenter3716@gmail.com</li>
            </ul>
          </div>

          {/* Links - takes up 1 column on desktop, centered on mobile */}
          <div className="text-left text-white -ml-8 text-lg">
            <ul className="flex flex-col no-left-padding text-left md:items-start space-y-2">
              <li>
                <a href="/building" className="text-white">
                  The Building
                </a>
              </li>
              <li>
                <a href="/neighborhood" className="text-white">
                  Neighborhood
                </a>
              </li>
              <li>
                <a href="/availability" className="text-white">
                  Availability
                </a>
              </li>
              <li>
                <a href="/gallery" className="text-white">
                  Gallery
                </a>
              </li>
              <li>
                <a href="/team" className="text-white">
                  Team
                </a>
              </li>
              <li>
                <a href="/contact" className="text-white">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="md:flex justify-between flex-col sm:flex-row items-center text-[#FFFFFF] -ml-6 pt-0 md:mt-10 pb-0">
        <ul className="mt-4 pt-24 md:pt-0 mb-4 antialiased tracking-[-0.16px] text-center max-w-[600px] w-full mx-auto flex flex-col items-center text-opacity-100">
          <li className="relative px-2">© Union Center 2025</li>
        </ul>
      </div>
    </div>
  );
}
